<template>
  <div>
    <a v-scroll-to="'#topNavbar'" class="page-scroll-top">
      <div>
        <i class="fas fa-chevron-up"></i>
        <p>PAGE UP</p>
      </div>
    </a>
    <div class="social-footer">
      <a
        href="https://www.facebook.com/fordays.tw"
        target="_blank"
        rel="noopener"
      >
        <img src="@/assets/public/images/footer/ic_facebook_default.svg" alt />
      </a>
      <a
        href="https://www.instagram.com/fordays_japan/"
        target="_blank"
        rel="noopener"
      >
        <img src="@/assets/public/images/footer/ic_instagram_default.svg" alt />
      </a>
      <a
        href="https://youtube.com/user/FORDAYS1997"
        target="_blank"
        rel="noopener"
      >
        <img src="@/assets/public/images/footer/ic_youtube_default.svg" alt />
      </a>
      <a
        href="https://liff.line.me/1645278921-kWRPP32q/?accountId=jkj1166v"
        target="_blank"
        rel="noopener"
      >
        <img src="@/assets/public/images/footer/ic_line_default.svg" alt />
      </a>
    </div>
    <div class="app-footer">
      <img src="@/assets/public/images/app_QR_Code.jpg" alt />
    </div>
    <footer class="footer">
      <div class="container">
        <p class="footer-text">
          Copyright © FORDAYS Co.,Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "PublicFooter",
};
</script>
